import { Typography } from "@material-ui/core";
import { connect } from "react-redux";
import { ServiceResponse } from "../Login/Messages";

const AccessDenied = (props: any) => {
  const { isLoading } = props;
  const message = isLoading
    ? ServiceResponse.getMessage("app", "loading")
    : ServiceResponse.getMessage("app", "accessDenied");
  const messageDetail = isLoading
    ? ""
    : ServiceResponse.getMessage("app", "noPermMsg");

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          marginTop: 10,
        }}
      >
        <Typography variant="h6" color="primary" align="center">
          {message}
        </Typography>
        <Typography variant="body1" color="primary" align="center">
          {messageDetail}
        </Typography>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return {};
};

const mapStateToProps = (state: any) => {
  return {
    errorMessage: state.loginReducer.errorMessage,
    isLoading: state.loginReducer.isLoading,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccessDenied);
